module.exports = __webpack_public_path__ + "img/second-day-9.b2120180.png";